import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import {
    Typography,
    colors,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Divider,
    Slide,
    Button
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
    cancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    },
    aceptar: {
        color: theme.palette.btn.green,
        '&:hover': {
            backgroundColor: theme.palette.btn.green,
            color: theme.palette.btn.white
        }
    },
    normal: {
        color: theme.palette.btn.blue,
        '&:hover': {
            backgroundColor: theme.palette.btn.blue,
            color: theme.palette.btn.white
        }
    }
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const AvisoConfirmacion = ({ open, title, text, accept, cancel, textAcept, textCancel, ...props }) => {
    const classes = useStyles();
    const [textoAceptar, setTextoAceptar] = useState('Aceptar');
    const [textoCancelar, setTextoCancelar] = useState('Cancelar');

    useEffect(() => {
        if (textAcept != null && textCancel != null) {
            setTextoAceptar(textAcept);
            setTextoCancelar(textCancel);
        }
    }, [textAcept, textCancel]);
    return (
        <div>
            <Dialog id="avisoConfirmacion" sx={{ zIndex: 5000 }} open={open} TransitionComponent={Transition} keepMounted>
                <form>
                    <DialogTitle>
                        <Typography variant="title">{title}</Typography>
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <DialogContentText>
                            <Typography variant="menuTitle"> {text} </Typography>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button id="btnCancelar" className={textCancel != null ? classes.normal : classes.cancelar} onClick={cancel}>
                            {textoCancelar}
                        </Button>
                        <Button id="btnAceptar" className={textAcept != null ? classes.normal : classes.aceptar} onClick={accept}>
                            {textoAceptar}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
};

export default AvisoConfirmacion;
